module.exports = __webpack_public_path__ + "static/media/message-success.d126b112.svg";